import React, { useState } from "react";
import atx from "../assets/atx.png";
import htx from "../assets/htx.png";
import dfw from "../assets/dfw.png";
import sa from "../assets/SA.png";
import tx from "../assets/tx.png";
import G from "../assets/Google.png";
import fLogo from "../assets/F-Logo4.png";
import mLogo from "../assets/M-logo4.png";
import logo from "../assets/MBT Hand Logo2.png";
import hand from "../assets/MBT Hand Logo-Dark.png";
import her from '../assets/woman (1).png';
import him from '../assets/man (1).png';
import them from '../assets/couple (1).png';
import preg from '../assets/pregnant.png';
import cPhne from '../assets/cellPhone.png';
import { Link } from 'react-router-dom';
import { Divider, Modal } from 'antd';
import { Phone, Mail, MessageSquare } from 'lucide-react';

function DefaultLayout(props) {
    const city = props.city;
    const user = props.userType;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            <div className="myNAV p-2 sticky-top shadow-l bg-white" style={{ borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}>
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <a href="/">
                            <img src={hand} width="80" />
                        </a>
                        {props.city ? <>
                            <Link to={`/${city}/for`}>
                                <img src={city === "Austin" ? atx : city === "Dallas-DFW" ? dfw : city === "SanAntonio" ? sa : city === "Houston" ? htx : tx} width="55" className="navIMG" />
                            </Link>
                            <img src={user === "him" ? him : user === "her" ? her : user === "them" ? them : user === "pregnant" ? preg : ""} width="40" className="navIMG" />
                        </> : ""}
                    </div>
                    <div className='dropdown text-end me-3'>
                        <button type="button" className="btn btn-warning dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown" aria-expanded="false" >
                            {"Menu "}
                        </button>
                        <ul
                            className="dropdown-menu text-small"
                            data-popper-placement="bottom-end"
                        >
                            <li className="d-inline-flex align-items-center">
                                <a className="dropdown-item" href="/">
                                    Home
                                </a>
                            </li>
                            {user && user !== "him" ? <li className="d-inline-flex align-items-center">
                                <a className="dropdown-item" href="#book">
                                    Book Appointment
                                </a>
                            </li> : ""}
                            {user && user !== "him" ? <li className="d-inline-flex align-items-center">
                                <a className="dropdown-item" href="https://dashboard.mobilebodytherapy.com" target="_blank">
                                    Create an Account
                                </a>
                            </li> : ""}

                            {user && user !== "him" ? <li className="d-inline-flex align-items-center">
                                <Link className="dropdown-item" to="/volunteer">
                                    Volunteer
                                </Link>
                            </li>
                                : ""}
                            <li className="d-inline-flex align-items-center">
                                <a className="dropdown-item" href="https://maps.app.goo.gl/KEDsgzgpJzr7ts5f8?g_st=ic" target="_blank">
                                    Find Us on Google
                                </a>
                            </li>
                            <li className="d-inline-flex align-items-center">
                                <a className="dropdown-item" href="#testimonials">
                                    Testamonials
                                </a>
                            </li>
                            <li className="d-inline-flex align-items-center">
                                <a className="dropdown-item" onClick={showModal} style={{ cursor: "pointer" }}>
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/*             <hr />
 */}            <div className="content">{props.children}</div>
            <Divider />
            <div className="d-flex flex-column align-items-center">
                <div className="d-inline-flex">
                    <p className="pe-2">Find Us on</p>
                    <a href="https://maps.app.goo.gl/KEDsgzgpJzr7ts5f8?g_st=ic" style={{ textDecoration: "none", color: "black" }}>
                        <img src={G} width="30" />
                    </a>
                </div>
                {user === "him" ? <img src={mLogo} width="165" /> : user === "her" ? <img src={fLogo} width="165" /> : <img src={logo} width="115" />}
                <p className={(user === "pregnant") || (user === "them") ? "pt-3" : "no-pad"}>&copy;2026 Mobile Body Therapy.<br />Professional therapeutic &amp; tantric services throughout Texas.</p>
                <div id="contact" className='rounded shadow msg' onClick={showModal}>
                    <img src={cPhne} width="35px" />
                    &nbsp;&nbsp;Contact Us
                </div>
                <Modal title="Contact Us" open={isModalOpen} onCancel={handleCancel} footer={[]}>
                    <Divider />
                    <div className="d-flex flex-column">
                        <div className="d-inline-flex justify-content-start pb-4">
                            <a hhref="tel:7372310251" className="d-flex align-items-center p-3 rounded border border-secondary hover:border-warning transition w-100" style={{ textDecoration: "none" }}>
                                <div className="bg-warning bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "48px", height: "48px", flexShrink: 0 }}>
                                    <Phone className="text-warning" size={24} />
                                </div>
                                <div>
                                    <p className="fw-bold text-dark mb-0">Text</p>
                                    <p className="text-muted mb-0 small">(737) 231-0251</p>
                                </div>
                            </a>
                        </div>
                        <div className="d-inline-flex justify-content-start pb-4">
                            <a hhref="sms:7372310251" className="d-flex align-items-center p-3 rounded border border-secondary hover:border-warning transition w-100" style={{ textDecoration: "none" }}>
                                <div className="bg-primary bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "48px", height: "48px", flexShrink: 0 }}>
                                    <MessageSquare className="text-primary" size={24} />
                                </div>
                                <div>
                                    <p className="fw-bold text-dark mb-0">Text</p>
                                    <p className="text-muted mb-0 small">(737) 231-0251</p>
                                </div>
                            </a>
                        </div>
                        <div className="d-inline-flex justify-content-start pb-4">
                            <a href="sms:Admin@MobileBodyTherapy.com" className="d-flex align-items-center p-3 rounded border border-secondary hover:border-warning transition w-100" style={{ textDecoration: "none" }}>
                                <div className="bg-primary bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "48px", height: "48px", flexShrink: 0 }}>
                                    <Phone className="text-primary" size={24} />
                                </div>
                                <div>
                                    <p className="fw-bold text-dark mb-0">iMessage/Facetime</p>
                                    <p className="text-muted mb-0 small">Admin@MobileBodyTherapy.com</p>
                                </div>
                            </a>
                        </div>
                        <div className="d-inline-flex justify-content-start pb-4">
                            <a href="mailto:Admin@MobileBodyTherapy.com" className="d-flex align-items-center p-3 rounded border border-secondary hover:border-warning transition w-100" style={{ textDecoration: "none" }}>
                                <div className="bg-success bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: "48px", height: "48px", flexShrink: 0 }}>
                                    <Mail className="text-success" size={24} />
                                </div>
                                <div>
                                    <p className="fw-bold text-dark mb-0">Email</p>
                                    <p className="text-muted mb-0 small">Admin@MobileBodyTherapy.com</p>
                                </div>
                            </a>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}

export default DefaultLayout